import React, { useEffect, useState, useRef } from "react";
import { registerOrganization2, getUserData } from '../../components/Api';
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import * as colors from "../../assets/css/Colors";
// Loader
import Loader from '../../components/Loader';

import Darkimg from '../../assets/img/curve2.png';
import whiteimg from '../../assets/img/curve1.png';
import Darkbg from '../../assets/img/Registration-Organization-bg.webp';
import whitebg from '../../assets/img/Registration-Organization-bg.webp';
import Lottie from 'lottie-react';
import Darkloginimg from '../../assets/json/student-black.json';
import whiteloginimg from '../../assets/json/student-white.json';
import ToolTip from '../../assets/json/tooltip.json'
import Imagegif from "../../components/Image_gif";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

// 
import { PDFDocument } from 'pdf-lib';
import * as pdfjsLib from 'pdfjs-dist/webpack';
import 'pdfjs-dist/web/pdf_viewer.css';
import { BsFillPatchQuestionFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import useAuthRedirect from '../../login/useAuthRedirect';
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";



const Organizationregister = () => {

    useAuthRedirect(); // This will handle the redirection based on is_firstLogin

    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState("");
    // Function to handle opening the modal with relevant content
    const handleShowModal = (content) => {
        setModalContent(content);
        setShowModal(true);
    };

    // Function to close the modal
    const handleCloseModal = () => {
        setShowModal(false);
        setModalContent("");
    };

    const [tooltip, setTooltip] = useState({
        show: false,
        message: '',
        label: '',
        position: { top: 0, left: 0 }
    });

    const handleIconClick = (message, event, label) => {
        const { top, left, height } = event.target.getBoundingClientRect();
        setTooltip({
            show: true,
            message: message,
            label: label,
            position: { top: top + height + window.scrollY, left: left + 20 }
        });
    };

    const hideTooltip = () => {
        setTooltip({ show: false, message: '', label: '', position: { top: 0, left: 0 } });
    };
    // State to toggle input data visibility
    const [showPassword, setShowPassword] = useState(false);
    const [showOrgName, setShowOrgName] = useState(false);
    const [showRegNumber, setShowRegNumber] = useState(false);
    const [showEmail, setShowEmail] = useState(false);
    const [showMobileNumber, setShowMobileNumber] = useState(false);
    const [showUsername, setShowUsername] = useState(false);
    const [filePreviews, setFilePreviews] = useState({
        logo: null,
        background_image: null
    });
    const logoRef = useRef(null);
    const background_imageRef = useRef(null);
    const [password, setPassword] = useState('');

    const lightloginURL = whiteloginimg;
    const darkloginURL = Darkloginimg;

    // erroe massage open popup 

    const [show, setShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [messageInfo, setMessageInfo] = useState({ message: [], type: '' });
    const navigate = useNavigate(); // Initialize useNavigate

    const handleShow = (message, type = 'error', show = true) => {
        setMessageInfo({ message, type });
        setShow(show);
        if (type === 'success') {
            setTimeout(() => {
                setShow(false);
                navigate('/'); 
            }, 5000);
        }
    };

    const [formData, setFormData] = useState({
        organization_type: '',
        organization_id: '',
        logo: '',
        background_image: '',
        social_icon: '',
        social_link: '',
        location: '',
        website_link: '',
        establishment_date: '',
        grade: '',
        type: '',
        director_name: '',
        affiliation_name: '',
        about_info: '',
        mission: '',
        director_info: '',
        organization_story: '',
        technology_info: '',
        discipline: '',
        pedagogy: '',
        security: '',
        achievement: '',
        teacher_bullying: '',
        curricular_activity: '',
    });
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState(null);
    const [userData, setUserData] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccessMessage(null);
        setIsLoading(true); // Start loader

        // Prepare form data using FormData
        const formDataToSend = new FormData();

        Object.keys(formData).forEach((key) => {
            if (key === 'logo' || key === 'background_image') {
                const file = userData[key];
                if (file) {
                    formDataToSend.append(key, file);
                }
            } else {
                formDataToSend.append(key, formData[key]);
            }
        });

          // Append the organization_id directly from user.organization.id
          if (user.organization?.id) {
            formDataToSend.append('organization_id', user.organization.id);
        }

        // Append the file inputs (logo and background_image)
        if (formData.logo) {
            formDataToSend.append('logo', formData.logo); // Append logo file
        }
        if (formData.background_image) {
            formDataToSend.append('background_image', formData.background_image); // Append background image file
        }

        // Append social links and icons dynamically if present
        socialLinks.forEach((social, index) => {
            formDataToSend.append(`social_icon[${index}]`, social.social_icon);
            formDataToSend.append(`social_link[${index}]`, social.social_link);
        });

        try {
            // Call your API with formDataToSend
            const response = await registerOrganization2(formDataToSend);

            if (response && response.status === 200) {
                // Handle successful response
                handleShow(["Registration successful!"], "success");
                resetForm(); // Reset the form after successful submission
            } else {
                handleShow(["Something went wrong with registration."], "error");
            }
        } catch (error) {
            console.error("Error during form submission:", error);

            // Check if the error response contains validation errors
            if (error.response && error.response.data && error.response.data.error) {
                const errors = error.response.data.error;
                const errorMessages = [];

                // Collect and flatten the error messages
                Object.keys(errors).forEach((field) => {
                    errorMessages.push(...errors[field]);
                });

                handleShow(errorMessages, "error");
            } else {
                // Handle other types of errors
                const errorMessage = error.message || "An unexpected error occurred.";
                handleShow([errorMessage], "error");
            }
        } finally {
            setIsLoading(false); // Stop loader
        }
    };




    const resetForm = () => {
        setFormData({
            organization_type: '',
            organization_id: '',
            logo: '',
            background_image: '',
            social_icon: '',
            social_link: '',
            location: '',
            website_link: '',
            establishment_date: '',
            grade: '',
            type: '',
            director_name: '',
            affiliation_name: '',
            about_info: '',
            mission: '',
            director_info: '',
            organization_story: '',
            technology_info: '',
            discipline: '',
            pedagogy: '',
            security: '',
            achievement: '',
            teacher_bullying: '',
            curricular_activity: '',
        });
    };
    // other function
    // Define image URLs and color dark mode and light mode change image start funtion
    const lightImageURL = whiteimg;
    const darkImageURL = Darkimg;

    const lightBgURL = whitebg;
    const darkBgURL = Darkbg;

    const [colorScheme, setColorScheme] = useState(
        window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

        const handleChange = (e) => {
            setColorScheme(e.matches ? 'dark' : 'light');
        };

        mediaQuery.addEventListener('change', handleChange);

        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, []);

    useEffect(() => {
        const element = document.querySelector(".ban-short-links");
        if (element) {
            element.classList.add("ani");
        }
    }, []);
    // Define image URLs and color dark mode and light mode change image end funtion

    //  gradient color Start
    const styles = {
        background: colorScheme === 'dark'
            ? `linear-gradient(90deg, ${colors.theme_black_color}, ${colors.theme_white_color} 95%)`
            : `linear-gradient(90deg, ${colors.theme_white_color}, ${colors.theme_black_color} 95%)`,
    };

    // isFocused input style start function
    const [focusedInput, setFocusedInput] = useState(null);

    const inputStyles = (isFocused) => ({
        borderColor: isFocused
            ? `${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color
            }`
            : '#000',
        boxShadow: isFocused
            ? `none`
            : 'none',
        transition: 'border-color 0.3s', // Add more transitions as needed
    });
    // isFocused input style end function

    const toggleOrgNameVisibility = () => {
        setShowOrgName(!showOrgName);
    };

    const toggleRegNumberVisibility = () => {
        setShowRegNumber(!showRegNumber);
    };

    const toggleEmailVisibility = () => {
        setShowEmail(!showEmail);
    };

    const toggleMobileNumberVisibility = () => {
        setShowMobileNumber(!showMobileNumber);
    };

    const toggleUsernameVisibility = () => {
        setShowUsername(!showUsername);
    };

    // image to connvet webp formate me 
    const handlePdfPopup = (message, type = 'success') => {
        handleShow([message], type);
    };

    const handleFileChange = async (e) => {
        const { name, files } = e.target;
        const file = files[0];
    
        // If there is no file, exit
        if (!file) return;
    
        try {
            const fileReader = new FileReader();
            fileReader.onload = async () => {
                try {
                    const fileBuffer = fileReader.result;
    
                    if (file.type.includes('image/')) {
                        const imageFile = new File([fileBuffer], file.name, { type: file.type });
                        
                        // Convert image to WebP
                        const canvas = document.createElement('canvas');
                        const context = canvas.getContext('2d');
                        const img = new Image();
                        img.onload = () => {
                            canvas.width = img.width;
                            canvas.height = img.height;
                            context.drawImage(img, 0, 0);
                            const webpDataUrl = canvas.toDataURL('image/webp');
                            const webpBlob = dataURLtoBlob(webpDataUrl);
                            const webpFile = new File([webpBlob], `${file.name.split('.')[0]}.webp`, { type: 'image/webp' });
    
                            setUserData((prevData) => ({
                                ...prevData,
                                [name]: webpFile
                            }));
                            setFilePreviews(prevState => ({
                                ...prevState,
                                [name]: URL.createObjectURL(webpFile)
                            }));
                            handlePdfPopup('Image converted to WebP and uploaded successfully.');
                        };
                        img.src = URL.createObjectURL(imageFile);
    
                    } else if (file.type.includes('application/pdf')) {
                        const pdfDoc = await PDFDocument.load(fileBuffer);
                        const pages = pdfDoc.getPages();
                        const webpFiles = [];
    
                        for (let i = 0; i < pages.length; i++) {
                            const pdfPage = await pdfjsLib.getDocument({ data: fileBuffer }).promise;
                            const pageData = await pdfPage.getPage(i + 1);
                            const viewport = pageData.getViewport({ scale: 2.0 });
    
                            const canvas = document.createElement('canvas');
                            canvas.width = viewport.width;
                            canvas.height = viewport.height;
                            const context = canvas.getContext('2d');
    
                            const renderContext = {
                                canvasContext: context,
                                viewport: viewport,
                            };
    
                            await pageData.render(renderContext).promise;
    
                            const webpDataUrl = canvas.toDataURL('image/webp');
                            const webpBlob = dataURLtoBlob(webpDataUrl);
                            const webpFile = new File([webpBlob], `page-${i + 1}.webp`, { type: 'image/webp' });
    
                            webpFiles.push(webpFile);
                        }
    
                        setUserData((prevData) => ({
                            ...prevData,
                            [name]: webpFiles[0]
                        }));
    
                        if (webpFiles.length > 0) {
                            setFilePreviews(prevState => ({
                                ...prevState,
                                [name]: URL.createObjectURL(webpFiles[0])
                            }));
                            handlePdfPopup('PDF processed and converted to WebP successfully.');
                        }
    
                    } else {
                        const genericFile = new File([fileBuffer], file.name, { type: file.type });
                        setUserData((prevData) => ({
                            ...prevData,
                            [name]: genericFile
                        }));
                        setFilePreviews(prevState => ({
                            ...prevState,
                            [name]: URL.createObjectURL(file)
                        }));
                        handlePdfPopup(`${name} file uploaded successfully.`);
                    }
    
                } catch (error) {
                    handlePdfPopup('Error processing file', 'error');
                    resetFileInput(name);
                }
            };
    
            fileReader.readAsArrayBuffer(file);
    
        } catch (error) {
            handleShow([`${name} failed to upload.`], 'error');
            resetFileInput(name);
        }
    };
    


    const resetFileInput = (name) => {
        if (name === 'logo' && logoRef.current) {
            logoRef.current.value = ''; // Reset the logo input field
        }
        if (name === 'background_image' && background_imageRef.current) {
            background_imageRef.current.value = ''; // Reset the background input field
        }
    };


    const canvasToWebP = (canvas) => {
        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.readAsDataURL(blob);
            }, 'image/webp');
        });
    };

    const dataURLtoBlob = (dataURL) => {
        const [header, data] = dataURL.split(',');
        const mime = header.match(/:(.*?);/)[1];
        const binary = atob(data);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], { type: mime });
    };


    // State to store social links
    const [socialLinks, setSocialLinks] = useState([{ social_icon: '', social_link: '' }]);

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedSocialLinks = [...socialLinks];

        // Update the specific social link
        updatedSocialLinks[index] = {
            ...updatedSocialLinks[index],
            [name]: value
        };

        setSocialLinks(updatedSocialLinks);
    };

    const addSocialLink = () => {
        setSocialLinks([...socialLinks, { social_icon: '', social_link: '' }]);
    };

    const removeSocialLink = (index) => {
        const updatedSocialLinks = socialLinks.filter((_, i) => i !== index);
        setSocialLinks(updatedSocialLinks);
    };

    const iconStyles = {
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        color: `${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`,
    };

    const [user, setUser] = useState(null); // State to hold user data
    const [loading, setLoading] = useState(true); // State to manage loading

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const data = await getUserData(); // Correctly fetch the user data
                console.log('Fetched User Data:', data); // Ensure we are getting the right data
                setUser(data); // Set the user data correctly
                setLoading(false); // Stop loading after data is fetched
            } catch (err) {
                setError('Failed to load user data');
                setLoading(false); // Stop loading if there’s an error
            }
        };

        fetchUserData(); // Call the function to fetch data
    }, []);

    // Show a loading message while the data is being fetched
    if (loading) {
        return <Loader />;
    }

    // Show an error message if there’s an error
    if (error) {
        return <div>{error}</div>;
    }



    return (
        <div className='Do-digital'>
            {isLoading && <Loader />}
            <Header />
            <div className="str ind2-home login-page">
                <div className="hom-head" style={{ backgroundImage: `url(${colorScheme === 'light' ? lightBgURL : darkBgURL})` }}>
                    <Container>
                        <Row>
                            <div className="ban-tit">
                                <h1>
                                    <b>Register with Complete <span style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>Organization<img src={colorScheme === 'light' ? lightImageURL : darkImageURL} alt="sharp" /></span>&nbsp;Details</b>
                                    <br />
                                    <span style={{ lineHeight: '32px', maxWidth: '867px', width: '100%', margin: 'auto', display: 'block', marginTop: '100px' }}>
                                        On this page, you can register your organization by filling out all the essential and detailed information. The form includes important fields like organization name, address, contact details, legal status, and required documents. Make sure to fill in all the information accurately to ensure a smooth registration process.
                                    </span>
                                </h1>
                            </div>
                        </Row>
                    </Container>
                </div>
            </div>

            <section className="mt-0 mb-60">
                <Container>
                    <Row>
                        <Col sm={5}>
                            <div style={{ position: 'sticky', top: '100px' }}>
                                <Lottie animationData={colorScheme === 'light' ? lightloginURL : darkloginURL} loop={true} />
                                {/* <img src={colorScheme === 'light' ? lightloginURL : darkloginURL} alt="Do-Digital" /> */}
                            </div>
                        </Col>
                        <Col sm={7}>
                            <div className="login-main">
                                <div style={styles} className="log-bor">&nbsp;</div>
                                <span style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }} className="steps">Fill in Detailed Information About Your Organization</span>
                                <div className="log log-1">
                                    <div className="login login-new">
                                        <p>Welcome to this exciting world. Let’s work together to make this world even more thrilling.</p>
                                        <Form onSubmit={handleSubmit}>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridName">
                                                    <Form.Label>Organization Name</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            type={showOrgName ? 'text' : 'password'}
                                                            name="name"
                                                            placeholder="Organization Name"
                                                            value={user.organization.name}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'name')}
                                                            onFocus={() => setFocusedInput('name')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                            readOnly
                                                        />
                                                        <FontAwesomeIcon
                                                            icon={showOrgName ? faEye : faEyeSlash}
                                                            onClick={toggleOrgNameVisibility}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                right: '32px',
                                                                transform: 'translateY(-50%)',
                                                                cursor: 'pointer'
                                                            }}
                                                        />

                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization Type', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>

                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={6} xs={12} controlId="formGridRegistrationNumber">
                                                    <Form.Label>Registration Number</Form.Label>
                                                    <div style={{ position: 'relative' }}>
                                                        <Form.Control
                                                            type={showRegNumber ? 'text' : 'password'}
                                                            name="registration_number"
                                                            placeholder="Registration Number"
                                                            value={user.organization.registration_number}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'registration_number')}
                                                            onFocus={() => setFocusedInput('registration_number')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                            readOnly
                                                        />
                                                        <FontAwesomeIcon
                                                            icon={showRegNumber ? faEye : faEyeSlash}
                                                            onClick={toggleRegNumberVisibility}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                right: '32px',
                                                                transform: 'translateY(-50%)',
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization Type', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                                <Form.Group as={Col} sm={6} xs={12} controlId="formGridEmail">
                                                    <Form.Label>Email</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            type={showEmail ? 'email' : 'password'}
                                                            name="email"
                                                            placeholder="Email"
                                                            value={user.organization.email}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'email')}
                                                            onFocus={() => setFocusedInput('email')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                            readOnly
                                                        />
                                                        <FontAwesomeIcon
                                                            icon={showEmail ? faEye : faEyeSlash}
                                                            onClick={toggleEmailVisibility}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                right: '32px',
                                                                transform: 'translateY(-50%)',
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization Type', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={6} xs={12} controlId="formGridUsername">
                                                    <Form.Label>Username</Form.Label>
                                                    <div style={{ position: 'relative' }}>
                                                        <Form.Control
                                                            type={showUsername ? 'text' : 'password'}
                                                            name="username"
                                                            placeholder="Username"
                                                            value={user.organization.username}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'username')}
                                                            onFocus={() => setFocusedInput('username')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                            readOnly
                                                        />
                                                        <FontAwesomeIcon
                                                            icon={showUsername ? faEye : faEyeSlash}
                                                            onClick={toggleUsernameVisibility}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                right: '32px',
                                                                transform: 'translateY(-50%)',
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization Type', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                                <Form.Group as={Col} sm={6} xs={12} controlId="formGridMobileNumber">
                                                    <Form.Label>Mobile Number</Form.Label>
                                                    <div style={{ position: 'relative' }}>
                                                        <Form.Control
                                                            type={showMobileNumber ? 'number' : 'password'}
                                                            name="mobilenumber"
                                                            placeholder="Mobile Number"
                                                            value={user.organization.mobilenumber}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'mobilenumber')}
                                                            onFocus={() => setFocusedInput('mobilenumber')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required

                                                        />

                                                        <FontAwesomeIcon
                                                            icon={showMobileNumber ? faEye : faEyeSlash}
                                                            onClick={toggleMobileNumberVisibility}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                right: '32px',
                                                                transform: 'translateY(-50%)',
                                                                cursor: 'pointer'
                                                            }}
                                                        />

                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization Type', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridOrganizationType">
                                                    <Form.Label>Organization Type</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            as="select"
                                                            name="organization_type"
                                                            value={formData.organization_type}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'organizationtype')}
                                                            onFocus={() => setFocusedInput('organizationtype')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required>
                                                            <option value="">Select Organization Type</option>
                                                            <option value="Government Schools">Government Schools</option>
                                                            <option value="Private Schools">Private Schools</option>
                                                            <option value="Government Colleges">Government Colleges</option>
                                                            <option value="Private Colleges">Private Colleges</option>
                                                        </Form.Control>

                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles} // Tooltip icon
                                                            onClick={(event) =>
                                                                handleIconClick(
                                                                    'Organization Type',
                                                                    event,
                                                                    'Select the type of organization from the list.'
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            {/* <Row className="mb-3">
                                                <Form.Group controlId="formGridPassword">
                                                    <Form.Label>Password</Form.Label>
                                                    <div style={{ position: 'relative' }}>
                                                        <Form.Control
                                                            type={showPassword ? 'text' : 'password'} // Toggle between password and text
                                                            placeholder="Password"
                                                            value={password}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            style={inputStyles(focusedInput === 'password')}
                                                            onFocus={() => setFocusedInput('password')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                        />
                                                       
                                                        <FontAwesomeIcon
                                                            icon={showPassword ? faEye : faEyeSlash}
                                                            onClick={togglePasswordVisibility}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                right: '32px',
                                                                transform: 'translateY(-50%)',
                                                                cursor: 'pointer',
                                                            }}
                                                        />
                                                       
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row> */}
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={6} xs={12} controlId="formGridLogo">
                                                    <Form.Label>Organization Logo</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={handleFileChange}
                                                            ref={logoRef}
                                                            name="logo"
                                                        />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                    {filePreviews.logo && (
                                                        <div className="file-preview mt-3" style={{ textAlign: 'center' }}>
                                                            <img src={filePreviews.logo} alt="File Preview" style={{ maxWidth: '50%', border: '1px solid', borderColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color, padding: '10px', borderRadius: '5px' }} />
                                                        </div>
                                                    )}
                                                </Form.Group>

                                                <Form.Group as={Col} sm={6} xs={12} controlId="formGridBackgroundImage">
                                                    <Form.Label>Organization Background Photo</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={handleFileChange}
                                                            ref={background_imageRef}
                                                            name="background_image"
                                                        />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                    {filePreviews.background_image && (
                                                        <div className="file-preview mt-3" style={{ textAlign: 'center' }}>
                                                            <img src={filePreviews.background_image} alt="File Preview" style={{ maxWidth: '50%', border: '1px solid', borderColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color, padding: '10px', borderRadius: '5px' }} />
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </Row>

                                            <Row className="mb-1 social-input-box-add-remove">
                                                <Form.Group as={Col} sm={4} xs={12}>
                                                    <div className="position-relative">
                                                        <Form.Label>Social Icon</Form.Label>
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                                <Form.Group as={Col} sm={5} xs={12}>
                                                    <div className="position-relative">
                                                        <Form.Label>Social Link</Form.Label>
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                                <Form.Group as={Col} sm={3} xs={12}>
                                                    <p onClick={addSocialLink} style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color, fontSize: '14px', fontWeight: 'bold', cursor: 'cell' }}>
                                                        Add More Social Link
                                                    </p>
                                                </Form.Group>
                                            </Row>
                                            {socialLinks.map((social, index) => (
                                                <Row className="mb-3 social-input-box-input" key={index}>
                                                    <Form.Group as={Col} sm={4} xs={12} controlId={`socialIcon-${index}`}>
                                                        <Form.Control
                                                            type="text"
                                                            name="social_icon"
                                                            placeholder="e.g., faFacebook"
                                                            value={social.social_icon}
                                                            onChange={(e) => handleInputChange(index, e)}
                                                            style={inputStyles(focusedInput === `icon${index}`)}
                                                            onFocus={() => setFocusedInput(`icon${index}`)}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm={5} xs={12} controlId={`socialLink-${index}`}>
                                                        <Form.Control
                                                            type="url"
                                                            name="social_link"
                                                            placeholder="https://your-link.com"
                                                            value={social.social_link}
                                                            onChange={(e) => handleInputChange(index, e)}
                                                            style={inputStyles(focusedInput === `link${index}`)}
                                                            onFocus={() => setFocusedInput(`link${index}`)}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm={3} xs={12} className="d-flex align-center justify-content">
                                                        <Button
                                                            style={{ fontSize: '14px', padding: '5px 10px', width: 'auto' }}
                                                            onClick={() => removeSocialLink(index)}
                                                            disabled={socialLinks.length === 1}
                                                        >
                                                            Remove
                                                        </Button>
                                                    </Form.Group>
                                                </Row>
                                            ))}


                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={6} xs={12} controlId="formGridSchoolLoctions">
                                                    <Form.Label>Organization Loctions</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            type="text"
                                                            name="location"
                                                            placeholder="School Loctions"
                                                            value={formData.location}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'schoolloctions')}
                                                            onFocus={() => setFocusedInput('schoolloctions')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                        />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                                <Form.Group as={Col} sm={6} xs={12} controlId="formGridSchoolWebsite">
                                                    <Form.Label>Organization Website</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            type="text"
                                                            name="website_link"
                                                            placeholder="School Website"
                                                            value={formData.website_link}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'schoolwebsite')}
                                                            onFocus={() => setFocusedInput('schoolwebsite')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                        />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={6} xs={12} controlId="formGridEstablished">
                                                    <Form.Label>Established</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            type="date"
                                                            name="establishment_date"
                                                            placeholder="Established"
                                                            value={formData.establishment_date}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'established')}
                                                            onFocus={() => setFocusedInput('established')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                        />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                right: '32px',
                                                                transform: 'translateY(-50%)',
                                                                cursor: 'pointer',
                                                                color: `${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`,
                                                            }}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                                <Form.Group as={Col} sm={6} xs={12} controlId="formGridGrades">
                                                    <Form.Label>Grades</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            as="select"
                                                            name="grade"
                                                            value={formData.grade}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'grades')}
                                                            onFocus={() => setFocusedInput('grades')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                        >
                                                            <option value=""> Plz Select Grades</option>
                                                            <option value="A">A</option>
                                                            <option value="B">B</option>
                                                            <option value="C">C</option>
                                                            <option value="D">D</option>
                                                        </Form.Control>
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={6} xs={12} controlId="formGridType">
                                                    <Form.Label>Type</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            as="select"
                                                            name="type"
                                                            value={formData.type}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'type')}
                                                            onFocus={() => setFocusedInput('type')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                        >
                                                            <option value=""> Plz Select</option>
                                                            <option value="Public">Public</option>
                                                            <option value="Private">Private</option>
                                                            <option value="International">International</option>
                                                            <option value="Boarding">Boarding</option>
                                                        </Form.Control>
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                right: '32px',
                                                                transform: 'translateY(-50%)',
                                                                cursor: 'pointer',
                                                                color: `${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`,
                                                            }}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                                <Form.Group as={Col} sm={6} xs={12} controlId="formGridPrincpalName">
                                                    <Form.Label>Organization (Princpal / Director) Name</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            type="text"
                                                            name="director_name"
                                                            placeholder="Organization (Princpal / Director) Name"
                                                            value={formData.director_name}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'princpalname')}
                                                            onFocus={() => setFocusedInput('princpalname')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                        />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridAffiliationName">
                                                    <Form.Label>Affiliation Name</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            type="text"
                                                            name="affiliation_name"
                                                            placeholder="Affiliation Name"
                                                            value={formData.affiliation_name}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'affiliationname')}
                                                            onFocus={() => setFocusedInput('affiliationname')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required
                                                        />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridAboutUs" className="input-hight-auto">
                                                    <Form.Label>About-Us ( Histary And Development )</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control as="textarea" rows={4}
                                                            name="about_info"
                                                            placeholder="About Us"
                                                            value={formData.about_info}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'aboutus')}
                                                            onFocus={() => setFocusedInput('aboutus')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridSchoolMission" className="input-hight-auto">
                                                    <Form.Label>Organization Mission</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control as="textarea" rows={4}
                                                            placeholder="Organization Mission"
                                                            name="mission"
                                                            value={formData.mission}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'schoolmission')}
                                                            onFocus={() => setFocusedInput('schoolmission')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridSPDI" className="input-hight-auto">
                                                    <Form.Label>Organization (Princpal / Director) Information</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control as="textarea" rows={4}
                                                            name="director_info"
                                                            placeholder="Organization (Princpal / Director) Information"
                                                            value={formData.director_info}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'spdi')}
                                                            onFocus={() => setFocusedInput('spdi')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridOrganizationStory" className="input-hight-auto">
                                                    <Form.Label>Organization Story</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control as="textarea" rows={4}
                                                            name="organization_story"
                                                            placeholder="Organization Story"
                                                            value={formData.organization_story}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'organization_story')}
                                                            onFocus={() => setFocusedInput('organization_story')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridOrganizationEducationalTechnology" className="input-hight-auto">
                                                    <Form.Label>Organization Educational Technology</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control as="textarea" rows={4}
                                                            name="technology_info"
                                                            placeholder="Organization Educational Technology"
                                                            value={formData.technology_info}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'organizationeducationaltechnology')}
                                                            onFocus={() => setFocusedInput('organizationeducationaltechnology')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridOrganizationDisciplineTowardsStudents" className="input-hight-auto">
                                                    <Form.Label>Organization Discipline Towards Students</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control as="textarea" rows={4}
                                                            name="discipline"
                                                            placeholder="Organization Discipline Towards Students"
                                                            value={formData.discipline}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'organizationDisciplinetowardsstudents')}
                                                            onFocus={() => setFocusedInput('organizationDisciplinetowardsstudents')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridOrganizationpedagogy" className="input-hight-auto">
                                                    <Form.Label>Organization Pedagogy</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control as="textarea" rows={4}
                                                            name="pedagogy"
                                                            placeholder="Organization Pedagogy"
                                                            value={formData.pedagogy}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'organizationpedagogy')}
                                                            onFocus={() => setFocusedInput('organizationpedagogy')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridOrganizationSecurity" className="input-hight-auto">
                                                    <Form.Label>Organization Security</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control as="textarea" rows={4}
                                                            name="security"
                                                            placeholder="Organization Security"
                                                            value={formData.security}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'organizationsecurity')}
                                                            onFocus={() => setFocusedInput('organizationsecurity')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridOrganizationArchitecture" className="input-hight-auto">
                                                    <Form.Label>Organization Architecture</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control as="textarea" rows={4}
                                                            name="achievement"
                                                            placeholder="Organization Architecture"
                                                            value={formData.achievement}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'organizationarchitecture')}
                                                            onFocus={() => setFocusedInput('organizationarchitecture')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridTeachersBullying" className="input-hight-auto">
                                                    <Form.Label>Teachers Bullying</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control as="textarea" rows={4}
                                                            name="teacher_bullying"
                                                            placeholder="Teachers Bullying"
                                                            value={formData.teacher_bullying}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'teachersbullying')}
                                                            onFocus={() => setFocusedInput('teachersbullying')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group as={Col} sm={12} xs={12} controlId="formGridOrganizationCulturalActivities" className="input-hight-auto">
                                                    <Form.Label>Organization Cultural Activities</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control as="textarea" rows={4}
                                                            name="curricular_activity"
                                                            placeholder="Organization Cultural Activities"
                                                            value={formData.curricular_activity}
                                                            onChange={handleChange}
                                                            style={inputStyles(focusedInput === 'organizationculturalactivities')}
                                                            onFocus={() => setFocusedInput('organizationculturalactivities')}
                                                            onBlur={() => setFocusedInput(null)}
                                                            required />
                                                        {/* Icon for tooltip */}
                                                        <BsFillPatchQuestionFill
                                                            style={iconStyles}
                                                            onClick={(event) => handleIconClick('Organization', event, 'Select the type of organization from the list.')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Row>

                                            <Button variant="primary" type="submit" style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                                                Register
                                            </Button>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>


            {/* First Popup */}
            <Modal
                show={show}
                onHide={() => setShow(false)}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title className={`error_massage_header ${messageInfo.type}`}>
                        {messageInfo.type === 'error' ? (
                            <Imagegif text={'error'} />
                        ) : (
                            <Imagegif text={'successfully'} />
                        )}
                        {show && (
                            <ul className={`error_massage_contet ${messageInfo.type}`}>
                                {messageInfo.message.map((msg, index) => (
                                    <li key={index} className={`${messageInfo.type}_message`}>
                                        {messageInfo.type === 'error' ? (
                                            <span className="error_icon"></span>
                                        ) : (
                                            <div className="success_icon">
                                                <h1>Thank You!</h1>
                                            </div>
                                        )}
                                        {msg}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </Modal.Title>
                </Modal.Header>
            </Modal>
            {/* Tooltip display */}

            {/* Modal for Tooltip */}
            <Modal
                show={tooltip.show}
                onHide={hideTooltip}
                backdrop="static"
                keyboard={false}
                centered
                className="tooltip-popup-style"
            >
                <Modal.Header closeButton>
                    <Modal.Title className={`error_massage_header`}>
                        {messageInfo.type === 'error' ? (
                            <Lottie animationData={ToolTip} loop={true} />
                        ) : (
                            <Lottie animationData={ToolTip} loop={true} />
                        )}

                        <ul className='information_massage_contet'>
                            <h4>{tooltip.message}</h4>
                            <li className='error_message'>
                                {tooltip.label}
                            </li>
                        </ul>

                    </Modal.Title>
                </Modal.Header>
            </Modal>
            <Footer />
        </div>
    )
}

export default Organizationregister